import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.dev';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  baseUrl = 'https://apim-dev-hilbertec.azure-api.net/package/api/';

  contactUs(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}email/contact-us`, data);
  }
}
